var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTripadvisor = function SvgTripadvisor(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M512,159.2h-90.24C326.08,76,185.92,76,90.24,159.2H0c0,0,20.48,24.96,28.8,48.32 C10.88,229.28,0,256.8,0,287.2c0,70.72,57.28,128,128,128c41.92,0,79.04-20.48,102.4-51.84l26.88,51.84l24.64-51.52 c23.36,31.04,60.16,51.52,102.08,51.52c70.72,0,128-57.28,128-128c0-30.4-10.88-57.92-28.8-79.68C491.52,184.16,512,159.2,512,159.2 z M128,383.2c-52.8,0-96-43.2-96-96s43.2-96,96-96s96,43.2,96,96S180.8,383.2,128,383.2z M256,287.2 c0-65.6-49.92-119.36-113.92-126.72c70.08-42.24,157.76-42.24,227.84,0C305.92,167.84,256,221.6,256,287.2z M384,383.2 c-52.8,0-96-43.2-96-96s43.2-96,96-96s96,43.2,96,96S436.8,383.2,384,383.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEB3B"
    },
    d: "M369.92,160.48C305.92,167.84,256,221.6,256,287.2c0-65.6-49.92-119.36-113.92-126.72 C212.16,118.24,299.84,118.24,369.92,160.48z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M128,351.2c-35.296,0-64-28.704-64-64s28.704-64,64-64s64,28.704,64,64S163.296,351.2,128,351.2z  M128,255.2c-17.632,0-32,14.368-32,32s14.368,32,32,32s32-14.368,32-32S145.632,255.2,128,255.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M384,351.2c-35.296,0-64-28.704-64-64s28.704-64,64-64s64,28.704,64,64S419.296,351.2,384,351.2z  M384,255.2c-17.664,0-32,14.368-32,32s14.336,32,32,32s32-14.368,32-32S401.664,255.2,384,255.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F44336"
    },
    cx: 128,
    cy: 287.2,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4CAF50"
    },
    cx: 384,
    cy: 287.2,
    r: 16
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTripadvisor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tripadvisor.6be6efcb.svg";
export { ForwardRef as ReactComponent };